import {createValue} from 'components/form/utils'
import filterOption from 'helpers/filterOption'
import getTitle from 'helpers/getTitle'
import {useAppConfig} from 'modules/local/AppConfigContext'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {SelectWidget} from 'views/AppLocals/custom/ReactSelectComponents'

export const CategoryField = ({name, value, onChange}) => {
    const t = useTranslate()
    const {categories = []} = useAppConfig('categories')
    const options = Array.from(categories || []).map((category) => ({
        label: t(getTitle(category)),
        value: category?.id,
        ...category,
    }))
    return (
        <SelectWidget
            value={value}
            mode="multiple"
            className="w-full"
            placeholder={t('click to select')}
            showSearch={true}
            allowClear={true}
            options={options}
            filterOption={filterOption}
            onChange={(value, option) => {
                onChange(createValue(name, value))
            }}
        />
    )
}

export default CategoryField
